<template>
  <v-list two-line v-scroll class="call-details">
    <v-list-tile
      v-for="(item, index) in users"
      :key="'call-item-' + index"
      style="height: 45px !important;"
    >
      <v-list-tile-avatar>
        <user-avatar 
          :avatar="item.avatar"
          :username="item.name" 
          :size="38"
        />
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title v-text="item.name" ></v-list-tile-title>
        <v-list-tile-sub-title v-text="item.code" v-if="item.code"></v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action v-if="item.p2p">
        <v-list-tile-action-text>P2P</v-list-tile-action-text>
      </v-list-tile-action>
    </v-list-tile>
<!--
    <v-divider
      v-if="(index + 1) < users.length"
      :inset="true"
      :key="'call-div-' + index"
    />-->
  </v-list>
</template>

<style lang="scss">
  .call-details {
    /*overflow-y: auto;
    padding: 10px 0px;*/ 
    background-size: 100%; 
    padding: 0;
    user-select: none;
  }
</style>

<script>
  import UserAvatar from '@common/UserAvatar.vue'
  import {EventBus} from '@/event-bus'

  export default {
    name: 'call-details',
    components: {
      UserAvatar
    },
    data: () => ({
      users: []
    }),
    methods: {
      update() {
        this.$store.dispatch('getCallUsers').then(users => {
          this.users = users
          console.log('-- users: ' + JSON.stringify(users))
        })
      }
    },
    mounted() {
      EventBus.$on('user-list-changed', (users) => {
        this.update()
      })

      this.update()
    },
    beforeDestroy() {
      EventBus.$off('user-list-changed')
    }
  }
</script>
